import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import type { NavItem } from '@/utils/navigation.utils';
import {
  generatePathWithExistingPrefix,
  isNavItemOrGroupActive,
  NavItemType,
} from '@/utils/navigation.utils';

type SubMenuItemProps = {
  item: NavItem;
  close: () => void;
};

export const SubMenuItem = ({ item, close }: SubMenuItemProps) => {
  const pathname = usePathname();
  const isSubActive = isNavItemOrGroupActive({
    currentPath: pathname,
    item,
  });
  const subItemHref = generatePathWithExistingPrefix({
    currentPath: pathname,
    targetPath: item.path,
    matchGamePrefix: item.navItemType === NavItemType.GamePage,
  });

  return (
    <Link
      className={cn(
        'flex items-center gap-2 rounded-lg px-3 py-2 hover:bg-light-blue-o10',
        isSubActive && 'text-light-blue'
      )}
      href={subItemHref}
      onClick={close}
    >
      {item.icon && <span className="shrink-0">{item.icon}</span>}
      <span className="font-medium text-white">{item.name}</span>
    </Link>
  );
};
